import { db } from "@db";
import { createSearchStore } from "@fetch/searchStore";
import type { InterproResult, InterproSearch } from "./types";

export const useInterproStore = createSearchStore<
  InterproSearch,
  InterproResult
>({
  searchesTable: () => db.interproSearches,
  resultsTable: () => db.interproResults,
});
